import React, { Component } from 'react';
import './index.scss';

class Warning extends Component {
  close = async () => {
    let userAgent = navigator.userAgent;
    if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
      window.location.href = 'about:blank';
      await window.close();
    } else {
      window.opener = null;
      await window.open('', '_self');
      await window.close();
    }
  };

  render() {
    return (
      <div className={'facebook-fail'}>
        <div className={'facebook-close'}>
        </div>
        <div className={'facebook-result'}>
          <img src={require('../../../assets/overseas-share/warning.png')} alt=""/>
        </div>
        <p className={'facebook-title'}>This account has gotten Trail Premium already</p>
        <p className={'facebook-describe'}>It only can take 7-day iSlide Trail Premium form each account.</p>
      </div>
    );
  }
}

export default Warning;
